import { ArrowRight, Check, TrendingUp } from "lucide-react";
import { Terminal } from "./Terminal";
import { WaitlistForm } from "./WaitlistForm";
import { LIVE_URL } from "@/lib/api";

const POINTS = [
  "10+ years of NSE & BSE data",
  "AI writes the entry, exit & stop rules",
  "Paper trading before real capital",
  "Marketplace limited to SEBI-registered RAs",
];

export const Hero = () => (
  <section id="top" className="relative pt-16 overflow-hidden tn-grid-bg" data-testid="hero-section">
    <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-[900px] h-[600px] tn-glow pointer-events-none" />
    <div className="relative max-w-[1152px] mx-auto px-5 md:px-8 pt-16 md:pt-20 pb-20 grid lg:grid-cols-[1.05fr_1fr] gap-14 items-center">
      <div className="tn-reveal">
        <span className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-wider text-[var(--tn-cyan)] border border-[rgba(34,211,238,0.35)] bg-[rgba(34,211,238,0.06)] rounded-full px-3 py-1.5" data-testid="hero-badge">
          <i className="w-1.5 h-1.5 rounded-full bg-[var(--tn-cyan)] tn-pulse" /> Coming soon · Waitlist open
        </span>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.08] tracking-tight mt-6">
          Build, backtest and run <span className="text-[var(--tn-cyan)]">AI trading strategies</span> on the Indian markets
        </h1>
        <p className="text-base md:text-lg text-[var(--tn-muted)] mt-6 leading-relaxed">
          Trading Nifty is being built as an AI research desk for NSE &amp; BSE traders and investors. Describe an idea in plain English, get a complete strategy with entry, exit and stop-loss rules, test it on a decade of historical data, run it on live signals with virtual money— then follow verified live performance on{" "}
          <a href={LIVE_URL} target="_blank" rel="noreferrer" className="text-[var(--tn-text)] hover:text-[var(--tn-cyan)]">live.tradingnifty.in</a>.
        </p>
        <div className="flex flex-wrap gap-3 mt-8">
          <a href="#waitlist" className="tn-btn h-11" data-testid="hero-join-waitlist-btn">Join the early-access waitlist <ArrowRight size={16} /></a>
          <a href={LIVE_URL} target="_blank" rel="noreferrer" className="tn-btn-ghost h-11" data-testid="hero-live-performance-btn"><TrendingUp size={16} /> See live performance</a>
        </div>
        <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-2 mt-7">
          {POINTS.map((p) => (
            <li key={p} className="flex items-center gap-2 text-sm text-[var(--tn-muted)]"><Check size={15} className="text-[var(--tn-green)]" />{p}</li>
          ))}
        </ul>
      </div>
      <div className="tn-reveal"><Terminal /></div>
    </div>
    <div id="waitlist" className="relative max-w-[1152px] mx-auto px-5 md:px-8 pb-24 scroll-mt-20">
      <div className="tn-reveal rounded-2xl border border-[var(--tn-line)] bg-[rgba(12,17,24,0.85)] backdrop-blur p-6 md:p-10 grid lg:grid-cols-[1fr_1.3fr] gap-10" data-testid="hero-waitlist-card">
        <div>
          <h2 className="font-display text-2xl md:text-3xl font-semibold">Get early access</h2>
          <p className="text-[var(--tn-muted)] mt-3 leading-relaxed text-sm md:text-base">
            Waitlist members get first access to the beta, founding-member pricing and a free backtesting allowance. Launching first for NIFTY, BANKNIFTY, equity and F&amp;O strategies.
          </p>
        </div>
        <WaitlistForm source="hero" />
      </div>
    </div>
  </section>
);
